import { TransactionItemDrawerMode } from '@/features/transaction_items/List/type';
import { useTranslation } from '@/i18n';
import { ButtonGroup, ButtonV2 } from '@moneyforward/ap-frontend-components';
import { FC, memo, useMemo } from 'react';

export type Props = {
  mode: TransactionItemDrawerMode;
  onClose: () => void;
  isLoading: boolean;
  isSubmitDisabled?: boolean;
};

export const TransactionItemFooter: FC<Props> = memo(
  ({ mode, onClose, isLoading, isSubmitDisabled = false }) => {
    const { t } = useTranslation();

    const footer = useMemo(() => {
      return (
        <ButtonGroup direction='horizontal'>
          <ButtonV2 isSecondary onClick={onClose} testId='cancel-button'>
            {t('cancel')}
          </ButtonV2>
          <ButtonV2
            type='submit'
            form='transaction_item_form'
            testId='save-button'
            isDisabled={isLoading || isSubmitDisabled}
          >
            {t(`transaction_items.drawer.${mode}.save`)}
          </ButtonV2>
        </ButtonGroup>
      );
    }, [mode, t, onClose, isLoading, isSubmitDisabled]);

    return footer;
  }
);

TransactionItemFooter.displayName = 'TransactionItemFooter';
